import type { ErrorInfo } from "react"

import type { ErrorData } from "./types"

const UNSERIALIZABLE_MESSAGE = "Unserializable error value"

export const toError = (value: unknown): Error => {
  if (value instanceof Error) return value
  if (typeof value === "string") return new Error(value)
  if (value === null || value === undefined) return new Error(String(value))

  try {
    return new Error(JSON.stringify(value) || UNSERIALIZABLE_MESSAGE)
  } catch {
    return new Error(UNSERIALIZABLE_MESSAGE)
  }
}

export const toErrorData = (
  value: unknown,
  errorInfo?: ErrorInfo | null,
): ErrorData => {
  const error = toError(value)
  return {
    timestamp: Date.now(),
    message: error.message,
    stack: error.stack,
    componentStack: errorInfo?.componentStack ?? undefined,
    url: window.location.origin + window.location.pathname,
    userAgent: navigator.userAgent,
  }
}
